import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {NetworkApiService} from '../../../services/api/network/online/network/network-api.service';
import {OfflineNetworkApiService} from '../../../services/api/network/offline/network/offline-network-api.service';
import {DataItemToVisualsMappersService} from '../../../network/services/map/data-item-to-visuals-mappers/data-item-to-visuals-mappers.service';
import {ChooseTopologyItemApiService} from '../services/choose-topology-item-api/choose-topology-item-api.service';
import {OneTimeConfirmationDialogService} from '../../../dialogs/one-time-confirmation-dialog/service/one-time-confirmation-dialog.service';
import {ChooseTopologyDataItemToVisualsMappersService} from '../services/choose-topology-data-item-to-visuals-mappers/choose-topology-data-item-to-visuals-mappers.service';
import * as _ from 'lodash';
import {TopologyElementType} from '../../../services/enums/topology-element-type.enum';
import {ChooseTopologyItemContextMenuService} from '../services/choose-topology-item-context-menu/choose-topology-item-context-menu.service';
import {ContextMenuComponent} from '@perfectmemory/ngx-contextmenu';

@Component({
  selector: 'choose-topology-item-container',
  templateUrl: './choose-topology-item-container.component.html',
  styleUrls: ['./choose-topology-item-container.component.less']
})
export class ChooseTopologyItemContainerComponent implements OnInit {

  constructor(private userPrivilege: UserPrivilegeService,
              private networkApiService: NetworkApiService,
              private offlineNetworkApiService: OfflineNetworkApiService,
              private dataItemToVisualsMappersService: ChooseTopologyDataItemToVisualsMappersService,
              private mainMapDataItemToVisualsMappersService: DataItemToVisualsMappersService,
              private chooseTopologyItemApiService: ChooseTopologyItemApiService,
              private contextMenuService: ChooseTopologyItemContextMenuService,
              private oneTimeConfirmationDialogService: OneTimeConfirmationDialogService) {}

  @ViewChild(ContextMenuComponent, {static: false}) public basicMenu: ContextMenuComponent;

  @Output() onClick = new EventEmitter<any>();
  @Output() onReady = new EventEmitter<any>();
  @Input() diagramId;
  @Input() set options(options) {
    if (_.isEmpty(options)) { return; }

    this.selectedItemsObject = options.selectedItemsObject;
    this.parameters = {};
    this.parameters.mapFilter = false;
    this.elementType = options.type;

    this.initializeConfigurations(options.selectionConfigurations);
    this.initializeMapConfigurations(options.isSingleSelection);
    this.dialogOpened = true;

    this.selectedNodes = options.preSelectedItems.nodes;
    this.selectedEdges = options.preSelectedItems.edges;

    this.lastState = {
      nodes: this.selectedNodes,
      edges: this.selectedEdges
    };

    if (!_.isNil(this.diagramApi)) {
      this.diagramApi.select(this.lastState);
    }

    this.storeKey = options.storeKey;
    this.type = options.type;
    this.viewOnly = options.viewOnly;

    this.showDialog();
  }

  onOk: () => void;
  canSubmit: boolean;
  formSettings = {valid: true, touched: false, dialogReady: false};

  selectedItemsObject: any = {};
  selectionConfigurations: any = {};
  parameters: any = {};
  diagramOptions: any = {};
  diagramApi: any;

  dialogOpened = false;
  searchTerms = [{term: 'name', operator: ':'}];

  showNetworkDiagram: boolean;

  savedMapConfigurations: any;

  selectedNodes: any;
  selectedEdges: any;

  diagramIdsForClusters: any;
  contextMenuData: any;

  storeKey: string;
  type: string;
  viewOnly = false;

  elementType: TopologyElementType;
  lastState: any;

  ngOnInit(): void {
    this.canSubmit = this.userPrivilege.isAuthorized();
  }

  showDialog(): void {
    setTimeout( () => {
      this.formSettings.dialogReady = true;
      setTimeout( () => {
        this.showNetworkDiagram = true;
      }, 0);
    }, 0);

    if (this.storeKey && !this.viewOnly) {
      setTimeout(() => {
        this.oneTimeConfirmationDialogService.showPopup(this.storeKey, 'Use Ctrl to select multiple topology elements.',
          () => {});
      }, 1000);
    }
  }

  closeDialog(): void {
    this.showNetworkDiagram = false;
    // this.sharedEventService.broadcast('closeChooseTopologyItemDialog');
  }

  initializeConfigurations(selectionConfigurations): void {
    this.selectionConfigurations.withOffline = selectionConfigurations.withOffline;
    this.selectionConfigurations.isSelectionLegal = selectionConfigurations.isSelectionLegal;
    this.selectionConfigurations.isCombinedViewDisplayed = selectionConfigurations.isCombinedViewDisplayed;
    this.diagramOptions.multipleSelection = selectionConfigurations.multipleSelection;
  }

  isCombinedViewDisplayedChanged(): void {
    if (this.selectionConfigurations.withOffline && this.diagramApi) {
      this.initializeDiagramWithData(false);
    }
  }

  selectNodes(nodesIds): void {
    this.diagramApi.selectNodes(nodesIds);
  }

  selectEdges(edgesIds): void {
    this.diagramApi.selectEdges(edgesIds);
  }

  initializeDiagramWithData(initial): void {
    const success = (data) => {
      this.diagramApi.setData(data.nodes, data.edges, data.clusters, true);

      this.diagramApi.select({
        nodes: this.selectedNodes,
        edges: this.selectedEdges
      });
    };

    this.fetchData(success);
  }

  fetchData(success): void {
    Promise.all([this.chooseTopologyItemApiService.getDataForCombinedShapes(this.parameters),
      this.chooseTopologyItemApiService.getDataForCombinedConnections(this.parameters),
      this.networkApiService.getClusters().toPromise(), this.offlineNetworkApiService.getClusters().toPromise()]).then(data => {
      const nodes: any = data[0];
      if (!this.selectionConfigurations.isCombinedViewDisplayed) {
        nodes.forEach(node => {
          if (node.dataItem.isOffline) {
            node.hidden = true;
          }
        });
      }

      const edges: any = data[1];
      if (!this.selectionConfigurations.isCombinedViewDisplayed) {
        edges.forEach(edge => {
          if (edge.dataItem.isOffline) {
            edge.hidden = true;
          }
        });
      }

      const onlineClusters: any = data[2];
      const offlineClusters: any = data[3];

      const result: any = {
        nodes,
        edges
      };
      if (this.selectionConfigurations.isCombinedViewDisplayed) {
        result.clusters = [...onlineClusters, ...offlineClusters];
      } else {
        result.clusters = onlineClusters;
      }

      success(result);
    });

  }

  updateDiagramData(): void {
    const success = (data) => {
      this.diagramApi.updateData(data.nodes, data.edges);
    };

    this.fetchData(success);
  }

  onDiagramReady(diagramApiLocal): void {
    this.diagramApi = diagramApiLocal;
    this.onReady.emit();
    if (this.dialogOpened) {
      this.initializeDiagramWithData(true);
    }
  }

  bringIntoView(): void {
    this.diagramApi.fit();
  }

  zoomIn(): void {
    this.diagramApi.zoomIn();
  }

  zoomOut(): void {
    this.diagramApi.zoomOut();
  }

  isSubmitEnabled(): boolean {
    return this.selectionConfigurations.isSelectionLegal(this.selectedItemsObject); // TODO - ok should be disable if not
  }

  onSelect(event): any {
    if (this.viewOnly) { return; }

    if (this.noItemClicked(event)) {
      this.diagramApi.select(this.lastState);
      return;
    }

    this.lastState = {
      nodes: event.nodes.map(item => item.id),
      edges: event.edges.map(item => item.id)
    };

    this.selectedItemsObject.node = event.nodes.filter((shape) => shape.shapeType === TopologyElementType.node);
    this.selectedItemsObject.voipPeer = event.nodes.filter((shape) => shape.shapeType === TopologyElementType.voipPeer);
    this.selectedItemsObject.clusterNode = event.nodes.filter((shape) => shape.shapeType === TopologyElementType.cluster);
    this.selectedItemsObject.connection = event.edges.filter((connection) => connection.connectionType === TopologyElementType.connection);
    this.selectedItemsObject.pCon = event.edges.filter((connection) => connection.connectionType === TopologyElementType.peerConnection);
    this.selectedItemsObject.clusterEdge = event.edges.filter((connection) => connection.connectionType === TopologyElementType.cluster);

    if (this.type === 'nodesAndPCons' && !this.onlyNodeAndPConsElementsSelected(this.selectedItemsObject)) {
      this.diagramApi.select({
        nodes: this.selectedItemsObject.node.map(item => item.id),
        edges: this.selectedItemsObject.pCon.map(item => item.id)
      });
    } else if (this.type === 'nodes' && !this.onlyNodeElementsSelected(this.selectedItemsObject)) {
      this.diagramApi.select({
        nodes: this.selectedItemsObject.node.map(item => item.id)
      });
    }  else if (this.type === 'pCons' && !this.onlyPConElementsSelected(this.selectedItemsObject)) {
      this.diagramApi.select({
        edges: this.selectedItemsObject.pCon.map(item => item.id)
      });
    } else if (this.type === 'nodesPConsAndVoipPeer' && !this.onlyNodePConsAndVoipPeerElementsSelected(this.selectedItemsObject)) {
      this.diagramApi.select({
        nodes: [...this.selectedItemsObject.node.map(item => item.id), ...this.selectedItemsObject.voipPeer.map(item => item.id)],
        edges: this.selectedItemsObject.pCon.map(item => item.id)
      });

    }

    this.onClick.emit(this.selectedItemsObject);
  }

  getSelectedNodeIds(): any {
    const result = [];
    this.selectedItemsObject.node.forEach(node => result.push(node.id));
    this.selectedItemsObject.voipPeer.forEach(voipPeer => result.push(voipPeer.id));
    return result;
  }

  getSelectedEdgesIds(): any {
    const result = [];
    this.selectedItemsObject.connection.forEach(node => result.push(node.id));
    this.selectedItemsObject.pCon.forEach(voipPeer => result.push(voipPeer.id));
    return result;
  }

  clearInputs = () => {
    this.parameters.searchObject.name = '';
  }

  drawPath(paths): void {
    if (_.isNil(this.diagramApi)) { return; }

    this.diagramApi.drawPath(paths);
  }

  termToValueMapper = (term: any) => {
    switch (term) {
      case 'name':
        return this.parameters.searchObject.name;
    }
  }

  initializeMapConfigurations(isSingleSelection): any {
    const conf = localStorage.getItem('MapConfigurations_online');
    this.savedMapConfigurations = conf ? JSON.parse(conf) : {};
    if (!!this.savedMapConfigurations.labelOptions) {
      this.dataItemToVisualsMappersService.setLabelOptions(this.savedMapConfigurations.labelOptions);
    }

    if (isSingleSelection && this.isInteractionConfigurationsExist()) {
      this.savedMapConfigurations.visjs.interaction.multiselect = false;
    }
  }

  getClusteredEdgePropertiesByEdges = (edgesInCluster) => {
    return this.mainMapDataItemToVisualsMappersService.getClusteredEdgeProperties(edgesInCluster);
  }

  getClusteredNodePropertiesByNodes = (nodesInCluster) => {
    return this.mainMapDataItemToVisualsMappersService.getClusteredNodeProperties(nodesInCluster);
  }

  onContextMenu($event): any {
    const rightClickedElement = $event.contextMenuObject.element;
    this.contextMenuData = this.contextMenuService.prepareContextMenuActions(this.diagramApi, rightClickedElement);
  }

  drawPaths(paths): void {

  }

  private isNoSelection(selectedItemsObject): boolean {
    return _.isEmpty(selectedItemsObject.node) &&
        _.isEmpty(selectedItemsObject.voipPeer) &&
        _.isEmpty(selectedItemsObject.connection) &&
        _.isEmpty(selectedItemsObject.pCon);
  }

  private onlyNodeElementsSelected(selectedItemsObject: any): boolean {
    return _.isEmpty(selectedItemsObject.voipPeer) &&
        _.isEmpty(selectedItemsObject.connection) &&
        _.isEmpty(selectedItemsObject.pCon) &&
        this.isNoClusterItemsSelected(selectedItemsObject);
  }

  private onlyPConElementsSelected(selectedItemsObject: any): boolean {
    return _.isEmpty(selectedItemsObject.node) &&
        _.isEmpty(selectedItemsObject.voipPeer) &&
        _.isEmpty(selectedItemsObject.connection) &&
        this.isNoClusterItemsSelected(selectedItemsObject);
  }

  private onlyNodeAndPConsElementsSelected(selectedItemsObject: any): boolean {
    if (this.isNoSelection(this.selectedItemsObject)) {
      return true;
    }
    return _.isEmpty(selectedItemsObject.voipPeer) &&
      _.isEmpty(selectedItemsObject.connection) &&
      this.isNoClusterItemsSelected(selectedItemsObject) &&
      (!_.isEmpty(selectedItemsObject.node) || !_.isEmpty(selectedItemsObject.pCon));
  }

  private onlyNodePConsAndVoipPeerElementsSelected(selectedItemsObject: any): boolean {
    if (this.isNoSelection(this.selectedItemsObject)) {
      return true;
    }
    return _.isEmpty(selectedItemsObject.connection) &&
      this.isNoClusterItemsSelected(selectedItemsObject) &&
      (!_.isEmpty(selectedItemsObject.node) || !_.isEmpty(selectedItemsObject.pCon));
  }

  private isNoClusterItemsSelected(selectedItemsObject): boolean {
    return _.isEmpty(selectedItemsObject.clusterNode) &&
      _.isEmpty(selectedItemsObject.clusterEdge);
  }

  private isInteractionConfigurationsExist(): boolean {
    return this.savedMapConfigurations &&
        this.savedMapConfigurations.visjs &&
        this.savedMapConfigurations.visjs.interaction;
  }

  private noItemClicked(event): boolean {
    return (event.nodes.length + event.edges.length) === 0 && !event.ctrlKey;
  }
}
